import React from "react";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import VTAdminInvoices from "../page/VTAdminInvoices";

export default function LandingAdminInvoices({page}) {
    return (
        <>
            <Header headerType="AdminPayInvoiceOnly"/>
            <VTAdminInvoices/>
            <Footer/>
        </>
    );
}